import React from 'react';

function Footer() {
    return (
        <footer className='footer-container'>
            <p>&copy; 2026 Crifo Robin Portfolio - All rights reserved.</p>
        </footer>
    );
}

export default Footer;
